import { Configuration, VesselKpiSettingsApi } from '@rhim/rest/operatorDisplay';

const BASE_URL = '/api/operatordisplayservice/v1';

const configuration: Configuration = {} as Configuration;

export const vesselKpiSettingsApi = new VesselKpiSettingsApi(configuration, BASE_URL);
